import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
    getCategories,
    getCategoryView,
    getCategoryCompanies,
} from './categoryAPI'

export const getCategoriesAsync = createAsyncThunk(
    'categories/getCategories',
    async (payload) => {
        const response = payload === undefined ? await getCategories() : payload;
        return response;
    }
);

export const appendCategoriesAsync = createAsyncThunk(
    'categories/appendCategories',
    async (payload) => {
        const response = payload === undefined ? await getCategories() : payload;
        return response;
    }
);

export const getCurrentCategoryAsync = createAsyncThunk(
    'categories/currentCategory',
    async (slug) => {
        try {
            const response = await getCategoryView(slug);
            return response;
        } catch (e) {
            // trigger event for livewire
            var notFound = new CustomEvent('notFound', { detail: { method: 'categories/currentCategory', slug: slug } });
            window.dispatchEvent(notFound);
            throw new Error(e);
        }
    }
);

export const getCategoryCompaniesAsync = createAsyncThunk(
    'categories/getCategoryCompanies',
    async (payload) => {
        try {
            const response = payload === undefined ? await getCategoryCompanies(payload.slug, payload.params) : payload;
            return response;
        } catch (e) {
            var notFound = new CustomEvent('notFound', { detail: { method: 'categories/currentCategory', slug: payload.slug } });
            window.dispatchEvent(notFound);
            throw new Error(e);
        }
    }
);

const initialState = {
    categories: {
        status: 'idle',
        results: [],
    },
    currentCategory: null,
    currentCategoryStatus: 'idle',
};

const categories = createSlice({
    name: 'categories',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getCategoriesAsync.pending, (state, { payload }) => {
            state.categories.status = 'loading';
        })
            .addCase(getCategoriesAsync.rejected, (state) => {
                state.categories.results = [];
                state.categories.meta = [];
                state.categories.status = 'attempted';
            })
            .addCase(getCategoriesAsync.fulfilled, (state, { payload }) => {
                state.categories.results = payload?.data ?? [];
                state.categories.meta = payload?.meta ?? [];
                state.categories.status = 'attempted';
            })
            .addCase(appendCategoriesAsync.pending, (state, { payload }) => {
                state.categories.status = 'loading';
            })
            .addCase(appendCategoriesAsync.rejected, (state) => {
                state.categories.status = 'attempted';
            })
            .addCase(appendCategoriesAsync.fulfilled, (state, { payload }) => {
                state.categories.results = [...state.categories.results, ...payload?.data];
                state.categories.meta = payload?.meta;
                state.categories.status = 'attempted';
            })
            .addCase(getCurrentCategoryAsync.pending, (state, { payload }) => {
                state.currentCategoryStatus = 'loading';
            })
            .addCase(getCurrentCategoryAsync.rejected, (state, { payload }) => {
                state.currentCategory = null;
                state.currentCategoryStatus = 'attempted';
            })
            .addCase(getCurrentCategoryAsync.fulfilled, (state, { payload }) => {
                state.currentCategory = payload?.data;
                state.currentCategoryStatus = 'attempted';
            })
            .addCase(getCategoryCompaniesAsync.pending, (state, { payload }) => {
                state.currentCategoryStatus = 'loading';
            })
            .addCase(getCategoryCompaniesAsync.rejected, (state, { payload }) => {
                state.currentCategory = null;
                state.currentCategoryStatus = 'attempted';
            })
            .addCase(getCategoryCompaniesAsync.fulfilled, (state, { payload }) => {
                state.currentCategory.companies = [...state.currentCategory.companies, ...payload?.companies ];
                state.currentCategory.companies_pagination = payload?.pagination;
                state.currentCategoryStatus = 'attempted';
            })
    },
});

export {
    getCategories,
    getCategoryView,
    getCategoryCompanies
}
export default categories.reducer;

